<template>
  <div id="removeclass">
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
        >
        <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("invoice_number") }}
            </label>
            <app-input
              class="col-sm-9"
              type="text"
              :read-only="true"
              v-model="inputs.invoice_number"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("invoice_date") }}
            </label>
            <app-input
              class="col-sm-9"
              type="text"
              :read-only="true"
              v-model="inputs.invoice_date"
            />
          </div>
          <!-- <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("company") }}
            </label>
            <app-input
              class="col-sm-9"
              type="search-select"
              :list="this.company"
              :isAnimatedDropdown="true"
              :required="true"
              :placeholder="$t('select_company')"
              v-model="inputs.company"
            />
          </div> -->
          <!-- <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("package") }}
            </label>
            <app-input
              class="col-sm-9"
              type="search-select"
              :list="this.packages"
              :isAnimatedDropdown="true"
              :required="true"
              :placeholder="$t('select_package')"
              v-model="inputs.package"
            />
          </div> -->
          <div class="form-group row align-items-center">
            <label class="col-sm-3 mb-0">{{ $t("due_date") }}</label>
            <app-input
              class="col-sm-9"
              type="date"
              v-model="inputs.due_date"
              :placeholder="$t('select_valid_date')"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("status") }}
            </label>
            <app-input
              class="col-sm-9"
              type="select"
              :list="this.status"
              :required="true"
              :isAnimatedDropdown="true"
              v-model="inputs.status"
            />
          </div>
          <!-- <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("amount") }}
            </label>
            <app-input
              id="amount"
              class="col-sm-9"
              type="number"
              v-model="inputs.amount"
              :required="true"
            />
          </div> -->
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import { INVOICE_STORE, INVOICE_UPDATE,COMPANY_LIST, INVOICE_PACKAGE_LIST } from "../../../../Config/ApiUrl";
import AppLibrary from "../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends:AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      preloader: false,
      required: false,
      inputs: {},
      company: [],
      packages:[],
      status:[
        { id: "", value: "Select Amount Status" },
        { id: "succeeded", value: "Paid" },
        { id: "pending", value: "Overdue" },
      ],
      modalId: "demo-add-edit-Modal",
      modalTitle: 'Add',
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
   
    submit() {
      this.preloader = true;
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        let split = this.selectedUrl.split("/");
        this.inputs.invoice_id = split[6];
        if (this.inputs.due_date) this.inputs.due_date = this.getDateFormatForBackend(this.inputs.due_date);
        axiosPost(INVOICE_UPDATE, this.inputs)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
            this.$hub.$emit("reload-" + this.tableId);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
          });
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
    getcompany() {
      axiosGet(COMPANY_LIST)
        .then((response) => {
          
          this.company = response.data;
        })
        .catch((error) => {
          
        });
    },
    getPackages() {
      axiosGet(INVOICE_PACKAGE_LIST)
        .then((response) => {
          
          this.packages = response.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.getcompany();
    this.getPackages();
    // this.getPackageInfo();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
